import { useNavigate } from "react-router";

import {
   Site
} from "../../model/model";

import SiteForm from "./SiteForm";
import SessionStore from "../../model/SessionStore";

function EditSite({ site }: { site: Site }) {
  const navigate = useNavigate();

  const onFinish = (obj: Site) => {
   
    SessionStore.getClient().updateSite(obj, SessionStore.getBearer()).then( () => {
      navigate("/site/" + obj.id +"/edit");
    });
  };

  return <SiteForm initialValues={site} onFinish={onFinish} update/>;
}

export default EditSite;
